import { clsx } from 'clsx';
import { Button } from '../button/button';
import { DropdownMenu } from '../dropdown-menu/dropdown-menu';
import type { DropdownMenuItem } from '../dropdown-menu/list-item/dropdown-menu-list-item';
import { Skeleton } from '../loading/skeleton';
import type { PopoverAlign, PopoverSide } from '../popover/popover';
import { Typography } from '../typography';
import styles from './hours-indicator.module.scss';

export type HoursIndicatorState = 'loading' | 'open' | 'closed';

export interface HoursIndicatorProps {
  align?: PopoverAlign;
  closedLabel: string;
  items: DropdownMenuItem[];
  openLabel: string;
  side?: PopoverSide;
  state: HoursIndicatorState;
}

export function HoursIndicator({ align = 'end', closedLabel, items, openLabel, side = 'bottom', state }: HoursIndicatorProps) {
  return (
    <DropdownMenu
      activator={
        <Button
          affixIcon={
            <div className={styles.statusLightContainer}>
              <div className={styles.statusLight} />
            </div>
          }
          className={clsx(styles.hoursIndicator, styles[`state-${state}`])}
          size="small"
          variant="light"
        >
          {state === 'loading' ? (
            <Skeleton className={styles.bar} fillParent parentClassName={styles.loadingShimmer} />
          ) : (
            <Typography lineHeight="1rem" size="0.75rem" wrap="no-wrap">
              {state === 'open' ? openLabel : closedLabel}
            </Typography>
          )}
        </Button>
      }
      align={align}
      groupStyle="border"
      items={items}
      label="Hours"
      labelIsHidden
      matchActivatorWidth={false}
      popoverClassName={styles.popover}
      side={side}
      sideOffset={8}
    />
  );
}
